

function addPlugins(config, slot_name, plugins) {
  if (slot_name in config.pluginSlots === false) {
    config.pluginSlots[slot_name] = {
      keepDefault: true,
      plugins: []
    };
  }

  config.pluginSlots[slot_name].plugins.push(...plugins);
}

async function setConfig () {
  let config = {
    pluginSlots: {}
  };

  try {
    /* We can't assume FPF exists, as it's not declared as a dependency in all
     * MFEs, so we import it dynamically. In addition, for dynamic imports to
     * work with Webpack all of the code that actually uses the imported module
     * needs to be inside the `try{}` block.
     */
    const { DIRECT_PLUGIN, PLUGIN_OPERATIONS } = await import('@openedx/frontend-plugin-framework');
    addPlugins(config, 'desktop_header_slot', [
        {
          op: PLUGIN_OPERATIONS.Hide,
          widgetId: 'default_contents'
        }
        ]);
    addPlugins(config, 'desktop_header_slot', [
        {
          op: PLUGIN_OPERATIONS.Insert,
          widget: {
            id: 'ektu_desktop_header',
            type: DIRECT_PLUGIN,
            RenderWidget: () => {
              const React = require("react");
              const { FormattedMessage } = require('@edx/frontend-platform/i18n');
              const { useContext, useState, useRef, useEffect } = React;
              const { AppContext } = require("@edx/frontend-platform/react");
              const { FontAwesomeIcon } = require("@fortawesome/react-fontawesome");
              const { faUser, faGlobe, faChevronDown } = require("@fortawesome/free-solid-svg-icons");
              const { useIntl } = require('react-intl');

              const EKTU_PRIMARY = '#006D5B';
              const EKTU_DARK = '#013A3A';
              const EKTU_BORDER = '#d9e6e1';
              const EKTU_FONT = "'Atyp Display','Manrope','Helvetica Neue',Arial,sans-serif";

              // Подписи шапки. Этих id нет в каталогах переводов MFE, поэтому
              // без defaultMessage на нужном языке они всегда были бы
              // английскими. Если перевод появится в каталоге, FormattedMessage
              // возьмёт его, а этот словарь останется запасным вариантом.
              const EKTU_TEXT = {
                'nav.about':         { en: 'About Us',        ru: 'О нас',              kk: 'Біз туралы' },
                'nav.team':          { en: 'Our Team',        ru: 'Наша команда',       kk: 'Біздің команда' },
                'nav.edufusion':     { en: 'Edufusion Course Catalogue', ru: 'Каталог курсов Edufusion', kk: 'Edufusion курстарының каталогы' },
                'nav.courses':       { en: 'Explore Courses', ru: 'Просмотреть курсы',  kk: 'Курстарды қарау' },
                'nav.my_courses':    { en: 'My Courses',      ru: 'Мои курсы',          kk: 'Менің курстарым' },
                'nav.order_history': { en: 'Order History',   ru: 'История заказов',    kk: 'Тапсырыстар тарихы' },
                'nav.course_log':    { en: 'Course log',      ru: 'Журнал изменений курсов', kk: 'Курстардағы өзгерістер журналы' },
                'nav.profile':       { en: 'Profile',         ru: 'Профиль',            kk: 'Профиль' },
                'nav.account':       { en: 'Account',         ru: 'Учётная запись',     kk: 'Есептік жазба' },
                'nav.sign_out':      { en: 'Sign out',        ru: 'Выйти',              kk: 'Шығу' },
                'nav.register':      { en: 'Register',        ru: 'Зарегистрироваться', kk: 'Тіркелу' },
                'nav.signin':        { en: 'Sign in',         ru: 'Вход',               kk: 'Кіру' },
                'language.selector.label': { en: 'Choose Language', ru: 'Выберите язык', kk: 'Тілді таңдаңыз' },
              };

              const { authenticatedUser, config } = useContext(AppContext);
              const intl = useIntl();
              const username = (authenticatedUser && authenticatedUser.username) || '';
              const isAuthenticated = !!authenticatedUser;
              const lmsBaseUrl = config.LMS_BASE_URL || '';
              const currentLanguageCode = (intl.locale || 'en').split('-')[0];
              const cookieName = config.LANGUAGE_PREFERENCE_COOKIE_NAME || 'openedx-language-preference';

              const label = (id) => {
                const entry = EKTU_TEXT[id];
                return entry ? (entry[currentLanguageCode] || entry.en) : id;
              };

              // Языковая cookie принадлежит платформе: LMS пишет её на
              // SHARED_COOKIE_DOMAIN, а Tutor задаёт его равным хосту LMS. На
              // тот же домен ставятся cookie входа, поэтому все MFE её видят.
              // Пишем сюда же, иначе получаются две cookie с одним именем:
              // Django читает последнюю, MFE — первую, и языки расходятся.
              const languageCookieDomain = () => {
                try { return new URL(lmsBaseUrl).hostname; } catch (err) { return ''; }
              };

              const [languages, setLanguages] = useState([]);
              const [dropdownOpen, setDropdownOpen] = useState(false);
              const [avatarUrl, setAvatarUrl] = useState(null);
              const dropdownRef = useRef(null);

              // Раньше cookie ставилась на последние две части домена
              // (.ektu.kz): она мешала платформенной и уходила на все сайты
              // *.ektu.kz, включая edx.ektu.kz. Убираем её у тех, у кого она
              // осталась.
              useEffect(() => {
                const parts = window.location.hostname.split('.');
                if (parts.length < 3) { return; }
                const legacy = parts.slice(-2).join('.');
                if (legacy === languageCookieDomain()) { return; }
                document.cookie = cookieName + '=; path=/; domain=.' + legacy + '; max-age=0';
              }, []);

              useEffect(() => {
                let supported = config.SITE_SUPPORTED_LANGUAGES || config.AVAILABLE_LANGUAGES || [];
                if (!supported || supported.length === 0) {
                  supported = [
                    { code: 'en', name: 'English' },
                    { code: 'ru', name: 'Русский' },
                    { code: 'kk', name: 'Қазақша' },
                  ];
                }
                setLanguages(supported);
              }, [config]);

              // Аватар из профиля. Порядок источников: то, что уже лежит в
              // контексте (frontend-platform кладёт туда профиль, если
              // приложение вызывало hydrateAuthenticatedUser), затем прямой
              // запрос к аккаунту. Если картинки нет — остаётся иконка,
              // рисовать заглушку /static/default_50.png смысла нет.
              useEffect(() => {
                let cancelled = false;

                const absolute = (url) => (
                  url && url.charAt(0) === '/' ? lmsBaseUrl + url : url
                );

                if (!isAuthenticated) {
                  setAvatarUrl(null);
                  return undefined;
                }

                if (authenticatedUser.avatar) {
                  setAvatarUrl(absolute(authenticatedUser.avatar));
                  return undefined;
                }

                const img = authenticatedUser.profileImage;
                if (img && img.hasImage) {
                  setAvatarUrl(absolute(img.imageUrlLarge || img.imageUrlMedium));
                  return undefined;
                }
                if (img) {
                  // Профиль загружен, картинки у пользователя нет.
                  setAvatarUrl(null);
                  return undefined;
                }

                (async () => {
                  try {
                    const { getAuthenticatedHttpClient } = require('@edx/frontend-platform/auth');
                    const response = await getAuthenticatedHttpClient()
                      .get(lmsBaseUrl + '/api/user/v1/accounts/' + username);
                    const profileImage = response.data && response.data.profile_image;
                    if (!cancelled && profileImage && profileImage.has_image) {
                      setAvatarUrl(absolute(
                        profileImage.image_url_large || profileImage.image_url_medium
                      ));
                    }
                  } catch (err) {
                    console.error('EKTU avatar load failed:', err);
                  }
                })();

                return () => { cancelled = true; };
              }, [isAuthenticated, username, lmsBaseUrl, authenticatedUser]);

              useEffect(() => {
                const onClick = (ev) => {
                  if (dropdownRef.current && !dropdownRef.current.contains(ev.target)) {
                    setDropdownOpen(false);
                  }
                };
                document.addEventListener('mousedown', onClick);
                return () => document.removeEventListener('mousedown', onClick);
              }, []);

              const showLanguageSelector = (config.ENABLE_HEADER_LANGUAGE_SELECTOR ?? true) && languages.length > 1;

              // Тот же порядок, что у самой LMS (common/static/js/src/lang_edx.js):
              // сохранить pref-lang — ответ LMS сам поставит cookie на нужный
              // домен, — затем обновить язык сессии и перезагрузить страницу.
              const handleLanguageChange = async (e) => {
                const selectedCode = e.target.value;
                if (selectedCode === currentLanguageCode) { return; }

                // Для анонимного посетителя запроса к LMS нет, cookie — всё,
                // что хранит его выбор. Домен тот же, что у платформы.
                const domain = languageCookieDomain();
                document.cookie = cookieName + '=' + selectedCode + '; path=/'
                  + (domain ? '; domain=' + domain : '')
                  + '; max-age=31536000'
                  + (window.location.protocol === 'https:' ? '; secure; samesite=None' : '');

                try {
                  if (isAuthenticated) {
                    const { getAuthenticatedHttpClient } = require('@edx/frontend-platform/auth');
                    const client = getAuthenticatedHttpClient();
                    await client.patch(
                      lmsBaseUrl + '/api/user/v1/preferences/' + username,
                      { 'pref-lang': selectedCode },
                      { headers: { 'Content-Type': 'application/merge-patch+json' } }
                    );
                    const form = new URLSearchParams();
                    form.append('language', selectedCode);
                    await client.post(lmsBaseUrl + '/i18n/setlang/', form, {
                      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    });
                  }
                } catch (err) {
                  console.error('EKTU language switch failed:', err);
                }
                window.location.reload();
              };

              const navLinks = [
                { id: 'nav.about', href: lmsBaseUrl + '/about' },
                { id: 'nav.team', href: lmsBaseUrl + '/team' },
                { id: 'nav.edufusion', href: lmsBaseUrl + '/edufusion/' },
                { id: 'nav.courses', href: lmsBaseUrl + '/courses' },
              ];

              const menuItems = [
                { id: 'nav.my_courses', href: lmsBaseUrl + '/dashboard' },
                { id: 'nav.profile', href: (config.ACCOUNT_PROFILE_URL || lmsBaseUrl) + '/u/' + username },
                { id: 'nav.account', href: config.ACCOUNT_SETTINGS_URL || (lmsBaseUrl + '/account') },
                // Своя страница платформы: сервиса ecommerce, куда ведёт
                // штатная ссылка Open edX, здесь нет.
                { id: 'nav.order_history', href: lmsBaseUrl + '/halyk/orders/' },
                // Журнал изменений курсов (ektu_audit) — только администраторам
                // платформы: administrator в JWT — это is_staff.
                ...(authenticatedUser && authenticatedUser.administrator
                  ? [{ id: 'nav.course_log', href: lmsBaseUrl + '/course-log/' }] : []),
                // Последним: у последнего пункта своё оформление в .ektu-menu.
                { id: 'nav.sign_out', href: lmsBaseUrl + '/logout' },
              ];

              return (
                <div>
                  <style>{`
                    .ektu-hdr { background:#fff; border-top:4px solid ${EKTU_PRIMARY}; border-bottom:1px solid ${EKTU_BORDER}; box-shadow:0 2px 14px rgba(1,58,58,.06); width:100%; font-family:${EKTU_FONT}; }
                    .ektu-hdr__inner { max-width:1180px; margin:0 auto; display:flex; align-items:center; justify-content:space-between; height:70px; padding:0 24px; box-sizing:border-box; }
                    .ektu-hdr__left { display:flex; align-items:center; gap:28px; }
                    .ektu-hdr__logo img { height:42px; width:auto; display:block; }
                    .ektu-hdr__nav { display:flex; align-items:center; gap:4px; }
                    .ektu-hdr__nav a { color:${EKTU_DARK}; text-decoration:none; font-weight:600; font-size:15px; padding:9px 14px; border-radius:10px; white-space:nowrap; transition:background .16s ease,color .16s ease; }
                    .ektu-hdr__nav a:hover { background:rgba(0,109,91,.10); color:${EKTU_PRIMARY}; }
                    .ektu-hdr__right { display:flex; align-items:center; gap:12px; }
                    .ektu-lang { display:inline-flex; align-items:center; gap:7px; padding:6px 12px; background:rgba(0,109,91,.07); border:1px solid ${EKTU_BORDER}; border-radius:999px; margin:0; }
                    .ektu-lang:hover { background:rgba(0,109,91,.12); border-color:${EKTU_PRIMARY}; }
                    .ektu-lang select { -webkit-appearance:none; -moz-appearance:none; appearance:none; border:0; background:transparent; color:${EKTU_DARK}; font-family:${EKTU_FONT}; font-weight:600; font-size:14px; cursor:pointer; outline:none; padding:0 2px 0 0; }
                    .ektu-btn-solid { background:${EKTU_PRIMARY}; color:#fff; text-decoration:none; font-weight:600; font-size:14px; padding:9px 22px; border-radius:999px; }
                    .ektu-btn-solid:hover { background:${EKTU_DARK}; color:#fff; }
                    .ektu-btn-outline { background:transparent; color:${EKTU_PRIMARY}; border:1px solid ${EKTU_PRIMARY}; text-decoration:none; font-weight:600; font-size:14px; padding:8px 22px; border-radius:999px; }
                    .ektu-btn-outline:hover { background:${EKTU_PRIMARY}; color:#fff; }
                    .ektu-user { display:inline-flex; align-items:center; gap:10px; padding:6px 12px; border:1px solid ${EKTU_PRIMARY}; border-radius:999px; cursor:pointer; color:${EKTU_DARK}; font-weight:600; font-size:15px; background:#fff; transition:background .16s ease; }
                    .ektu-user:hover { background:rgba(0,109,91,.08); }
                    .ektu-user__avatar { width:30px; height:30px; border-radius:50%; background:${EKTU_PRIMARY}; color:#fff; display:flex; align-items:center; justify-content:center; font-size:14px; overflow:hidden; flex:none; }
                    .ektu-user__avatar img { width:100%; height:100%; object-fit:cover; display:block; border-radius:50%; }
                    .ektu-menu { position:absolute; right:0; top:calc(100% + 10px); background:#fff; border:1px solid ${EKTU_BORDER}; border-radius:14px; box-shadow:0 18px 44px rgba(1,58,58,.16); padding:8px; min-width:212px; z-index:1000; }
                    .ektu-menu a { display:block; padding:10px 14px; color:${EKTU_DARK}; text-decoration:none; font-weight:500; border-radius:9px; }
                    .ektu-menu a:hover { background:rgba(0,109,91,.10); color:${EKTU_PRIMARY}; }
                    .ektu-menu a:last-child { margin-top:4px; border-top:1px solid ${EKTU_BORDER}; color:${EKTU_PRIMARY}; font-weight:600; border-radius:0 0 9px 9px; }
                  `}</style>

                  <header className="ektu-hdr">
                    <div className="ektu-hdr__inner">
                      <div className="ektu-hdr__left">
                        <a className="ektu-hdr__logo" href={lmsBaseUrl || '/'}>
                          <img src={config.LOGO_URL} alt="EKTU" />
                        </a>
                        <nav className="ektu-hdr__nav">
                          {navLinks.map((link) => (
                            <a key={link.id} href={link.href}>
                              <FormattedMessage id={link.id} defaultMessage={label(link.id)} />
                            </a>
                          ))}
                        </nav>
                      </div>

                      <div className="ektu-hdr__right">
                        {showLanguageSelector && (
                          <label className="ektu-lang">
                            <FontAwesomeIcon icon={faGlobe} style={{ color: EKTU_PRIMARY, fontSize: '15px' }} />
                            <span className="sr-only">
                              <FormattedMessage id="language.selector.label" defaultMessage={label('language.selector.label')} />
                            </span>
                            <select value={currentLanguageCode} onChange={handleLanguageChange} aria-label={label('language.selector.label')}>
                              {languages.map((lang) => {
                                const code = lang.code || lang.value;
                                const name = lang.name || lang.label;
                                return <option key={code} value={code}>{name}</option>;
                              })}
                            </select>
                          </label>
                        )}

                        {isAuthenticated ? (
                          <div ref={dropdownRef} style={{ position: 'relative' }}>
                            <div className="ektu-user" onClick={() => setDropdownOpen(!dropdownOpen)}>
                              <span className="ektu-user__avatar">
                                {avatarUrl ? (
                                  <img
                                    src={avatarUrl}
                                    alt=""
                                    onError={() => setAvatarUrl(null)}
                                  />
                                ) : (
                                  <FontAwesomeIcon icon={faUser} />
                                )}
                              </span>
                              <span>{username}</span>
                              <FontAwesomeIcon icon={faChevronDown} style={{ fontSize: '12px', color: EKTU_PRIMARY }} />
                            </div>
                            {dropdownOpen && (
                              <div className="ektu-menu">
                                {menuItems.map((item) => (
                                  <a key={item.id} href={item.href}>
                                    <FormattedMessage id={item.id} defaultMessage={label(item.id)} />
                                  </a>
                                ))}
                              </div>
                            )}
                          </div>
                        ) : (
                          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <a className="ektu-btn-outline" href={lmsBaseUrl + '/register'}>
                              <FormattedMessage id="nav.register" defaultMessage={label('nav.register')} />
                            </a>
                            <a className="ektu-btn-solid" href={lmsBaseUrl + '/login'}>
                              <FormattedMessage id="nav.signin" defaultMessage={label('nav.signin')} />
                            </a>
                          </div>
                        )}
                      </div>
                    </div>
                  </header>
                </div>
              );
            }
          }
        }
        ]);
    addPlugins(config, 'mobile_main_menu_slot', [
        {
          op: PLUGIN_OPERATIONS.Modify,
          widgetId: 'default_contents',
          fn: (widget) => {
            const React = require("react");
            const { FormattedMessage, getLocale } = require('@edx/frontend-platform/i18n');
            const { useState, useEffect } = React;
            const { useIntl } = require('react-intl');
            const { getConfig } = require('@edx/frontend-platform');
            const { getAuthenticatedUser } = require('@edx/frontend-platform/auth');

            const EKTU_PRIMARY = '#006D5B';
            const lms = getConfig().LMS_BASE_URL || '';
            const cookieName = getConfig().LANGUAGE_PREFERENCE_COOKIE_NAME || 'openedx-language-preference';

            // Те же подписи и те же id, что в шапке для компьютера.
            const EKTU_TEXT = {
              'nav.about':         { en: 'About Us',        ru: 'О нас',             kk: 'Біз туралы' },
              'nav.team':          { en: 'Our Team',        ru: 'Наша команда',      kk: 'Біздің команда' },
              'nav.edufusion':     { en: 'Edufusion Course Catalogue', ru: 'Каталог курсов Edufusion', kk: 'Edufusion курстарының каталогы' },
              'nav.courses':       { en: 'Explore Courses', ru: 'Просмотреть курсы', kk: 'Курстарды қарау' },
              'nav.my_courses':    { en: 'My Courses',      ru: 'Мои курсы',         kk: 'Менің курстарым' },
              'nav.order_history': { en: 'Order History',   ru: 'История заказов',   kk: 'Тапсырыстар тарихы' },
              'nav.course_log':    { en: 'Course log',      ru: 'Журнал изменений курсов', kk: 'Курстардағы өзгерістер журналы' },
            };
            const lang = (getLocale() || 'en').split('-')[0];
            const label = (id) => {
              const entry = EKTU_TEXT[id];
              return entry ? (entry[lang] || entry.en) : id;
            };
            const item = (id, href) => ({
              type: 'item', href, content: <FormattedMessage id={id} defaultMessage={label(id)} />,
            });

            // См. комментарий в шапке для компьютера: cookie пишется на домен
            // платформы (хост LMS), старая на .ektu.kz удаляется.
            const languageCookieDomain = () => {
              try { return new URL(lms).hostname; } catch (err) { return ''; }
            };

            const LanguageSelector = () => {
              const config = getConfig();
              const intl = useIntl();
              const user = getAuthenticatedUser();
              const username = (user && user.username) || '';
              const isAuthenticated = !!user;
              const lmsBaseUrl = config.LMS_BASE_URL || '';
              const currentLanguageCode = (intl.locale || 'en').split('-')[0];
              const [languages, setLanguages] = useState([]);

              useEffect(() => {
                const parts = window.location.hostname.split('.');
                if (parts.length < 3) { return; }
                const legacy = parts.slice(-2).join('.');
                if (legacy === languageCookieDomain()) { return; }
                document.cookie = cookieName + '=; path=/; domain=.' + legacy + '; max-age=0';
              }, []);

              useEffect(() => {
                let supported = config.SITE_SUPPORTED_LANGUAGES || config.AVAILABLE_LANGUAGES || [
                  { code: 'en', name: 'English' },
                  { code: 'ru', name: 'Русский' },
                  { code: 'kk', name: 'Қазақша' },
                ];
                setLanguages(supported);
              }, []);

              const handleLanguageChange = async (e) => {
                const selectedCode = e.target.value;
                if (selectedCode === currentLanguageCode) { return; }
                const domain = languageCookieDomain();
                document.cookie = cookieName + '=' + selectedCode + '; path=/'
                  + (domain ? '; domain=' + domain : '')
                  + '; max-age=31536000'
                  + (window.location.protocol === 'https:' ? '; secure; samesite=None' : '');
                try {
                  if (isAuthenticated) {
                    const { getAuthenticatedHttpClient } = require('@edx/frontend-platform/auth');
                    const client = getAuthenticatedHttpClient();
                    await client.patch(
                      lmsBaseUrl + '/api/user/v1/preferences/' + username,
                      { 'pref-lang': selectedCode },
                      { headers: { 'Content-Type': 'application/merge-patch+json' } }
                    );
                    const form = new URLSearchParams();
                    form.append('language', selectedCode);
                    await client.post(lmsBaseUrl + '/i18n/setlang/', form, {
                      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    });
                  }
                } catch (err) {
                  console.error('EKTU language switch failed:', err);
                }
                window.location.reload();
              };

              if (languages.length <= 1) { return null; }
              return (
                <div style={{ padding: '12px 16px', borderTop: '1px solid #e6efec', background: '#f4f8f6' }}>
                  <select
                    value={currentLanguageCode}
                    onChange={handleLanguageChange}
                    aria-label="Language"
                    style={{ width: '100%', padding: '8px 12px', borderRadius: '8px', border: '1px solid #d9e6e1', fontSize: '14px', background: '#fff', color: EKTU_PRIMARY, fontWeight: 600 }}
                  >
                    {languages.map((l) => {
                      const code = l.code || l.value;
                      const name = l.name || l.label;
                      return <option key={code} value={code}>{name}</option>;
                    })}
                  </select>
                </div>
              );
            };

            const menu = [
              item('nav.my_courses', lms + '/dashboard'),
            ];
            if (getAuthenticatedUser()) {
              // Страница входа за ней всё равно не пустит анонима.
              menu.push(item('nav.order_history', lms + '/halyk/orders/'));
              if (getAuthenticatedUser().administrator) {
                menu.push(item('nav.course_log', lms + '/course-log/'));
              }
            }
            menu.push(
              item('nav.courses', lms + '/courses'),
              item('nav.team', lms + '/team'),
              item('nav.edufusion', lms + '/edufusion/'),
              item('nav.about', lms + '/about'),
              { type: 'custom', content: <LanguageSelector /> },
            );
            widget.content.menu = menu;
            return widget;
          }
        }
        ]);
    addPlugins(config, 'footer_slot', [
        {
          op: PLUGIN_OPERATIONS.Hide,
          widgetId: 'default_contents'
        }
        ]);
    addPlugins(config, 'footer_slot', [
        {
          op: PLUGIN_OPERATIONS.Insert,
          widget: {
            id: 'ektu_footer',
            type: DIRECT_PLUGIN,
            RenderWidget: () => {
              const React = require("react");
              const { FormattedMessage } = require('@edx/frontend-platform/i18n');
              const { useContext } = React;
              const { AppContext } = require("@edx/frontend-platform/react");

              const EKTU_PRIMARY = '#006D5B';
              const EKTU_DARK = '#013A3A';
              const EKTU_ACCENT = '#2fae8f';
              const EKTU_MUTED = '#9fc0b8';
              const FONT_DISPLAY = "'Atyp Display','Manrope','Helvetica Neue',Arial,sans-serif";
              const FONT_BODY = "'Manrope','Helvetica Neue',Arial,sans-serif";

              // Guides to working with Open edX, on the site of the Center for
              // Educational Technologies. The same link as in the LMS footer.
              const OPENEDX_HELP_URL = 'https://help.edtech.ektu.kz/ru';

              const { config } = useContext(AppContext);
              const lms = config.LMS_BASE_URL || '';
              const logo = config.LOGO_WHITE_URL || config.LOGO_TRADEMARK_URL || config.LOGO_URL;

              // Same three columns as the LMS footer (lms/templates/footer.html).
              const columns = [
                {
                  id: 'footer.learning', default: 'Learning',
                  links: [
                    { id: 'footer.course_catalog', default: 'Course catalog', href: lms + '/courses' },
                    { id: 'footer.about_university', default: 'About the university', href: lms + '/about' },
                  ],
                },
                {
                  id: 'footer.support', default: 'Support',
                  links: [
                    { id: 'footer.help', default: 'Help', href: lms + '/help' },
                    { id: 'footer.faq', default: 'Frequently asked questions', href: lms + '/faq' },
                    { id: 'footer.ask_question', default: 'Ask a question', href: lms + '/help/ask/' },
                  ],
                },
                {
                  id: 'footer.resources', default: 'Resources',
                  links: [
                    {
                      id: 'footer.openedx_resources', default: 'Resources for working with Open edX',
                      href: OPENEDX_HELP_URL, external: true,
                    },
                  ],
                },
              ];

              const legal = [
                { id: 'footer.honor_code', default: 'Honor Code', href: lms + '/honor' },
                { id: 'footer.public_offer', default: 'Public Offer Agreement', href: lms + '/tos' },
                { id: 'footer.data_consent', default: 'Consent to data collection and processing', href: lms + '/data-consent' },
                { id: 'footer.privacy_policy', default: 'Privacy Policy', href: lms + '/privacy' },
              ];

              return (
                <div>
                  <style>{`
                    .ektu-ftr {
                      background:${EKTU_DARK};
                      border-top:4px solid ${EKTU_PRIMARY};
                      width:100%;
                      font-family:${FONT_BODY};
                      line-height:1.5;
                    }
                    .ektu-ftr__top {
                      max-width:1180px; margin:0 auto; padding:44px 5vw 8px;
                      display:grid; grid-template-columns:minmax(0,1fr) minmax(0,2.6fr);
                      gap:32px; align-items:start;
                      /* The LMS has no global border-box reset, so its footer sizes the
                         1180px against the content box. MFEs ship Bootstrap, which does
                         set border-box globally — pin it back so both line up. */
                      box-sizing:content-box;
                    }
                    .ektu-ftr__logo img { max-height:48px; width:auto; display:block; }
                    .ektu-ftr__cols {
                      display:grid; grid-template-columns:repeat(3,minmax(0,1fr)); gap:28px;
                    }
                    .ektu-ftr__col { display:flex; flex-direction:column; gap:10px; min-width:0; }
                    .ektu-ftr__col-title {
                      color:#fff; font-family:${FONT_DISPLAY}; font-weight:700; font-size:13px;
                      line-height:1.3; letter-spacing:0.08em; text-transform:uppercase; margin:0 0 2px;
                    }
                    .ektu-ftr__col a {
                      color:${EKTU_MUTED}; font-family:${FONT_BODY}; font-size:14px; line-height:1.45;
                      text-decoration:none; transition:color .16s ease;
                    }
                    .ektu-ftr__col a:hover, .ektu-ftr__col a:focus { color:#fff; text-decoration:none; }

                    .ektu-ftr__inner {
                      max-width:1180px; margin:0 auto; padding:20px 5vw 8px;
                      display:flex; align-items:center; justify-content:space-between;
                      flex-wrap:wrap; gap:20px; box-sizing:content-box;
                    }
                    .ektu-ftr__nav { display:flex; flex-wrap:wrap; align-items:center; gap:28px; }
                    .ektu-ftr__nav a {
                      color:#fff; font-family:${FONT_DISPLAY}; font-weight:600; font-size:15px;
                      text-decoration:none; transition:color .18s ease;
                    }
                    .ektu-ftr__nav a:hover, .ektu-ftr__nav a:focus { color:${EKTU_ACCENT}; text-decoration:none; }

                    .ektu-ftr__copy {
                      max-width:1180px; margin:0 auto; padding:16px 5vw 4px;
                      border-top:1px solid rgba(255,255,255,0.12); color:${EKTU_MUTED}; font-size:13px;
                      box-sizing:content-box;
                    }

                    @media (max-width:860px){
                      .ektu-ftr__top { grid-template-columns:1fr; gap:28px; }
                    }
                    @media (max-width:600px){
                      .ektu-ftr__inner { flex-direction:column; align-items:flex-start; }
                      .ektu-ftr__nav { gap:16px; flex-direction:column; align-items:flex-start; }
                      .ektu-ftr__cols { grid-template-columns:1fr; gap:24px; }
                    }
                  `}</style>

                  <footer className="ektu-ftr">
                    <div className="ektu-ftr__top">
                      <div className="ektu-ftr__logo">
                        <a href={lms || '/'}>
                          {logo
                            ? <img src={logo} alt="EKTU" />
                            : <span style={{ color: '#fff', fontWeight: 700, fontSize: '20px' }}>EKTU</span>}
                        </a>
                      </div>

                      <div className="ektu-ftr__cols">
                        {columns.map(col => (
                          <nav className="ektu-ftr__col" key={col.id}>
                            <h2 className="ektu-ftr__col-title">
                              <FormattedMessage id={col.id} defaultMessage={col.default} />
                            </h2>
                            {col.links.map(l => (
                              <a
                                key={l.id}
                                href={l.href}
                                {...(l.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                              >
                                <FormattedMessage id={l.id} defaultMessage={l.default} />
                              </a>
                            ))}
                          </nav>
                        ))}
                      </div>
                    </div>

                    <div className="ektu-ftr__inner">
                      <nav className="ektu-ftr__nav">
                        {legal.map(l => (
                          <a key={l.id} href={l.href}>
                            <FormattedMessage id={l.id} defaultMessage={l.default} />
                          </a>
                        ))}
                      </nav>
                    </div>

                    <div className="ektu-ftr__copy">
                      {'\u00A9 2026 '}
                      <FormattedMessage
                        id="footer.university"
                        defaultMessage="East Kazakhstan Technical University"
                      />
                      {'. '}
                      <FormattedMessage id="footer.rights" defaultMessage="All rights reserved." />
                    </div>
                  </footer>
                </div>
              );
            }
          }
        }
        ]);
    if (process.env.APP_ID == 'authn') {
    }
    if (process.env.APP_ID == 'authoring') {
    }
    if (process.env.APP_ID == 'account') {
    }
    if (process.env.APP_ID == 'communications') {
    }
    if (process.env.APP_ID == 'discussions') {
    }
    if (process.env.APP_ID == 'gradebook') {
    }
    if (process.env.APP_ID == 'learner-dashboard') {
    }
    if (process.env.APP_ID == 'learning') {
    }
    if (process.env.APP_ID == 'ora-grading') {
    }
    if (process.env.APP_ID == 'profile') {
    }
  } catch (err) { console.error("env.config.jsx failed to apply: ", err);}

  return config;
}

export default setConfig;